<style lang="scss" scoped></style>
<template>
	<div>
		<template v-if="hasImg">
			<viewer :images="images"> <img v-for="(src, index) in images" :src="src" :key="index" :style="{ width: width + 'px', height: height + 'px', marginRight: '10px' }" /> </viewer>
		</template>
	</div>
</template>

<script>
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";
import Vue from "vue";
Vue.use(Viewer);
Viewer.setDefaults({
	Options: {
		inline: true,
		button: true,
		navbar: true,
		title: true,
		toolbar: true,
		tooltip: true,
		movable: true,
		zoomable: true,
		rotatable: true,
		scalable: true,
		transition: true,
		fullscreen: true,
		keyboard: true,
		url: "data-source",
	},
});
export default {
	name: "my-img-component",
	props: {
		width: {
			type: [Number, String],
			default: 150,
		},
		height: {
			type: [Number, String],
			default: 150,
		},
		images: {
			type: Array,
			required: true,
		},
	},
	computed: {
		hasImg() {
			const index = this.$props.images.findIndex((item) => {
				return item;
			});
			return index == -1 ? false : true;
		},
	},
};
</script>
